'use client';

import React from 'react';

export class ErrorBoundary extends React.Component<any, { hasError: boolean }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    const hasRefreshed = JSON.parse(
      window?.sessionStorage.getItem('retry-error-refreshed') || 'false'
    );
    if (
      error?.message &&
      chunkFailedMessage.test(error.message) &&
      !hasRefreshed
    ) {
      window?.sessionStorage.setItem('retry-error-refreshed', 'true');

      window?.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
